import React from 'react';
import { shape } from 'prop-types';
import MaterialAlert from '@mui/material/Alert';
import InfoIcon from '@mui/icons-material/Info';

const overrideIcons = {
  info: <InfoIcon fontSize="inherit" />,
};

const Alert = ({ sx, ...forwardedProps }) => {
  const { severity = 'success', variant = 'standard' } = forwardedProps;

  return (
    <MaterialAlert
      iconMapping={overrideIcons}
      slotProps={{
        icon: {
          sx: {
            alignItems: 'center',
            padding: 0,
          },
        },
        message: {
          sx: {
            padding: 0,
          },
        },
      }}
      sx={{
        alignItems: 'center',
        padding: 2,
        ...(variant === 'outlined' &&
          severity === 'warning' && {
            backgroundColor: 'surface.white',
            color: 'warning.dark',
          }),
        ...(variant === 'standard' &&
          severity === 'info' && {
            '& .MuiAlert-icon': {
              color: 'graphic.main',
            },
            backgroundColor: 'graphic.light',
            color: 'text.secondary',
            typography: 'body2',
          }),
        ...sx,
      }}
      {...forwardedProps}
    />
  );
};

Alert.propTypes = {
  sx: shape({}),
};

Alert.defaultProps = {
  sx: undefined,
};

export default Alert;
